import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { msalInstance } from './auth/msalInstance';
import { registerAccessTokenProvider } from './auth/initializeApiConfig';

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore();

msalInstance.initialize().then(async () => {
    // Handle redirect response before rendering to prevent infinite redirect loops
    await msalInstance.handleRedirectPromise();

    registerAccessTokenProvider(msalInstance);

    const container = document.getElementById('root');
    if (container) {
        const root = createRoot(container);
        root.render(
            <MsalProvider instance={msalInstance}>
                <Provider store={store}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </Provider>
            </MsalProvider>
        );
    }

    registerServiceWorker();
}).catch(error => {
    console.error('Failed to initialize MSAL instance', error);
});